/**
 * The one rounding rule for the cash payout fee: the action, the dialog preview and the fee the dialog sends
 * as confirmed all call it, so both sides get the same integer. Pure, so it runs on the client too.
 */
export function computeCashPayoutFee(amountMicrousd: number, feePercent: number): number {
  if (feePercent <= 0 || amountMicrousd <= 0) return 0
  return Math.round((amountMicrousd * feePercent) / 100)
}
